import styled, { css } from 'styled-components';
import { TextProps } from '.';
import { colorSemanticsArray } from '@/styles/theme';

export const Texto = styled.span<TextProps>`
  ${({ theme, $size, $weight, $align, $fontFamily }) => {
    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family[$fontFamily]});
      font-weight: ${theme.typography.font.weight[$weight]};
      line-height: ${theme.typography.font.line_height[$size]}px;
      text-align: ${$align};
    `;
  }};

  color: ${({ $highContrast, theme, $color }) => {
    if (colorSemanticsArray.includes($color))
      return theme.colors.semantic[$color]['9'];
    if ($highContrast) return theme.tokens.colors.text;
    if (!$color.includes('#'))
      return theme.colors[$color][`${$color}_alpha`][11];
    return $color;
  }};

  ${({ $quebraTexto }) => {
    if (!$quebraTexto)
      return css`
        white-space: nowrap;
        overflow: hidden;
      `;

    return css`
      word-break: break-word;
    `;
  }};

  ${({ $utilizarReticencias }) => {
    if (!$utilizarReticencias) return '';
    return css`
      text-overflow: ellipsis;
    `;
  }}

  text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
`;
